// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 3828) return "static/chunks/3828-ed63dfad92c9d5d7.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4704":"b346be9a6bf2bcd5","5757":"30e3a28474fa3dde","5798":"700a53eed607cf57","5930":"c41935a7ce51c069","7165":"facb1aec2e9903eb","7240":"5a7e9245f7c8a09e"}[chunkId] + ".js";
};